"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_tippy_1 = require("react-tippy");
require("react-tippy/dist/tippy.css");
var sectionTitlesTooltip_styles_1 = require("./sectionTitlesTooltip.styles");
var info_icon_1 = require("../../icons/info.icon");
exports.SectionTitlesTooltip = function (props) {
    var show = React.useState(false || props.show)[0];
    return (React.createElement("div", { className: sectionTitlesTooltip_styles_1.container, id: props.id },
        React.createElement(react_tippy_1.Tooltip, { html: React.createElement("div", { id: "section-titles-tooltip", className: sectionTitlesTooltip_styles_1.overrides },
                props.text && props.text,
                props.html && props.html), trigger: "mouseenter", arrow: true, open: show, theme: "dark" },
            React.createElement("span", null,
                React.createElement(info_icon_1.InfoIcon, { id: props.id + "-icon" })))));
};
